import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify';
import es from 'vuetify/lib/locale/es'
import { inicializar } from '@/../../cliente_comun/fuentes';

Vue.config.productionTip = false

new Vue({
  router,
	vuetify,
	created: function() {
		this.$vuetify.lang.locales.es = es
		this.$vuetify.lang.current = 'es'
	},
	mounted: function() {
		inicializar()
	},
  render: h => h(App)
}).$mount('#app')
